import type { PluginDefaultTranslationsObject, PluginLanguage } from '../types.js'

export const huTranslations: PluginDefaultTranslationsObject = {
  $schema: './translation-schema.json',
  'plugin-form-builder': {
    name: 'Név (kisbetű, speciális karakterek nélkül)',
    add: 'Hozzáadás',
    allowedFileTypes: 'Engedélyezett fájltípusok',
    allowedFileTypesDescription:
      'Korlátozza az engedélyezett fájltípusokat (pl. kép/*, alkalmazás/pdf). Hagyja üresen az összes típus engedélyezéséhez.',
    allowMultipleFiles: 'Több fájl engedélyezése',
    amountInCents: 'Az összeg centben',
    basePrice: 'Alapár',
    bcc: 'BCC',
    brand: 'Márka',
    cc: 'CC',
    checkboxPlural: 'Jelölőnégyzet Mezők',
    checkboxSingular: 'Jelölőnégyzet',
    checkedByDefault: 'Alapértelmezés szerint bejelölve',
    chooseConfirmationType:
      'Válassza ki, hogy az űrlap elküldése után üzenetet jelenítsen-e meg az oldalon, vagy átirányítson-e egy másik oldalra.',
    condition: 'Állapot',
    confirmationMessage: 'Megerősítő üzenet',
    confirmationType: 'Megerősítés típusa',
    countryPlural: 'Ország mezők',
    countrySingular: 'Ország',
    creditCard: 'Hitelkártya',
    customURL: 'Egyéni URL',
    datePlural: 'Dátum mezők',
    dateSingular: 'Dátum',
    defaultValue: 'Alapértelmezett érték',
    divide: 'Osztani',
    documentToLinkTo: 'Dokumentum, amelyre hivatkozni kell',
    doesNotEqual: 'Nem egyenlő',
    emailFrom: 'E-mail feladója',
    emailPlural: 'E-mail mezők',
    emailsDescription:
      'Egyéni e-mailek küldése az űrlap elküldésekor. Használjon vesszővel elválasztott listákat, ha ugyanazt az e-mailt több címzettnek szeretné elküldeni. Ha egy értékre szeretne hivatkozni ebből az űrlapból, tegye a mező nevét dupla szögletes zárójelbe, azaz {{firstName}}. Használhat egy helyettesítő karaktert {{*}} az összes adat kimenetére, és a {{*:table}} HTML-táblázat formázásához az e-mailben.',
    emailSingular: 'E-mail',
    emailTo: 'E-mail címre',
    equals: 'Egyenlő',
    field: 'Mező',
    fields: 'Mezők',
    fieldWidth: 'Mező szélessége (százalék)',
    hasAnyValue: 'Bármilyen értéke van',
    internalLink: 'Belső link',
    label: 'Címke',
    maxFileSize: 'Max fájlméret (bájt)',
    maxFileSizeDescription: 'Maximális fájlméret bájtban. Hagyja üresen korlátozás nélkül.',
    message: 'Üzenet',
    messageDescription: 'Írja be az e-mailben elküldendő üzenetet.',
    messagePlural: 'Üzenetblokkok',
    messageSingular: 'Üzenet',
    mimeType: 'MIME típus',
    mimeTypePlural: 'MIME típusok',
    mimeTypeSingular: 'MIME típus',
    multiply: 'Szorozni',
    numberPlural: 'Számmezők',
    numberSingular: 'Szám',
    optionPlural: 'Opciók',
    optionSingular: 'Opció',
    paymentFieldPlural: 'Fizetési mezők',
    paymentFieldSingular: 'Fizetés',
    paymentProcessor: 'Fizetésfeldolgozó',
    paymentStatus: 'Állapot',
    placeholder: 'Helyőrző',
    priceConditions: 'Ár feltételek',
    priceConditionsPlural: 'Ár feltételek',
    priceConditionsSingular: 'Ár Állapot',
    radioOptions: 'Rádiótulajdonság-beállítások',
    radioPlural: 'Rádiómezők',
    radioSingular: 'Rádió',
    redirect: 'Átirányítás',
    replyTo: 'Válasz erre',
    required: 'Kötelező',
    selectOptions: 'Válassza az Opciók lehetőséget',
    selectPlural: 'Válassza a Mezők lehetőséget',
    selectSingular: 'Válassza ki',
    statePlural: 'State Fields',
    stateSingular: 'állam',
    staticValue: 'Statikus érték',
    subject: 'Tárgy',
    submitButton: 'Gombcímke küldése',
    subtract: 'Kivonás',
    textareaPlural: 'Textarea Fields',
    textareaSingular: 'Textarea',
    textPlural: 'Szövegmezők',
    textSingular: 'Szöveg',
    title: 'Cím',
    token: 'token',
    uploadCollection: 'Gyűjtemény feltöltése',
    uploadCollectionDescription:
      'Válassza ki, hogy melyik feltöltési gyűjteményben tárolja a fájlokat',
    uploadFieldPlural: 'Mezők feltöltése',
    uploadFieldSingular: 'Feltöltés',
    urlToRedirectTo: 'URL az átirányításhoz',
    value: 'Érték',
    valueOfField: 'A mező értéke',
    valueType: 'Érték típusa',
  },
}

export const hu: PluginLanguage = {
  dateFNSKey: 'hu',
  translations: huTranslations,
}
